var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"index-ct"},[_c('button',{on:{"click":_vm.handleClick}},[_vm._v("dddd")])])])}
var staticRenderFns = []

export { render, staticRenderFns }